import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JeeMainsSession1HltEntryLinkComponent } from './jee-mains-session1-hlt-entry-link/jee-mains-session1-hlt-entry-link.component';
import { JeeMainsSession1HltEntryComponent } from './jee-mains-session1-hlt-entry/jee-mains-session1-hlt-entry.component';
import { JeeMainsSession2HltEntryComponent } from './jee-mains-session2-hlt-entry/jee-mains-session2-hlt-entry.component';
import { JeeMainsSession1RookieHltEntryComponent } from './jee-mains-session1-rookie-hlt-entry/jee-mains-session1-rookie-hlt-entry.component';
import { JeeMainsSession2RookieHltEmtryComponent } from './jee-mains-session2-rookie-hlt-entry/jee-mains-session2-rookie-hlt-emtry.component';
import { NeetHltEntryComponent } from './neet-hlt-entry/neet-hlt-entry.component';
import { NeeRookieHltEntryComponent } from './nee-rookie-hlt-entry/nee-rookie-hlt-entry.component';
const routes: Routes = [
   {
                path:'',component:JeeMainsSession1HltEntryLinkComponent,
                children:[
                  {
                    path:"jee", component:JeeMainsSession1HltEntryComponent
                  }, 
                   {
                    path:"jee2", component:JeeMainsSession2HltEntryComponent
                  }, 
                   {
                    path:"rookie", component:JeeMainsSession1RookieHltEntryComponent
                  }, 
                    {
                    path:"rookie2", component:JeeMainsSession2RookieHltEmtryComponent
                  }, 
                   {
                    path:"neet", component:NeetHltEntryComponent
                  },  
                   {
                    path:"neetRookie", component:NeeRookieHltEntryComponent
                  },  
                ]
                
              }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JeeMainsSession1EntryRoutingModule { }
